var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dash invite" }, [
    _c("div", { staticClass: "dash-section" }, [
      _c("div", { staticClass: "main-wrapper" }, [
        _c("div", { staticClass: "main-content" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", { staticClass: "header-top" }, [
              _vm._m(0),
              this.$route.name != "legal"
                ? _c(
                    "a",
                    { staticClass: "a-icon", attrs: { "href.prevent": "" } },
                    [
                      _c("vs-avatar", {
                        attrs: {
                          color: "#f9f9f9",
                          size: "42px",
                          src: require("../assets/img/ico-man.svg"),
                        },
                      }),
                      _c("p", { staticClass: "user-name" }, [
                        _vm._v(
                          _vm._s(_vm.name || _vm.$t("dash.header.myaccount"))
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "language-wrapper" },
                [
                  _c(
                    "vs-dropdown",
                    {
                      attrs: {
                        "vs-custom-content": "",
                        "vs-trigger-click": "",
                        color: "#B20564",
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "a-icon",
                          attrs: { "href.prevent": "" },
                        },
                        [
                          _c("p", { staticClass: "locale" }, [
                            _vm._v(_vm._s(this.$i18n.locale)),
                          ]),
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("keyboard_arrow_down"),
                          ]),
                        ]
                      ),
                      _c(
                        "vs-dropdown-menu",
                        { staticClass: "select-lang" },
                        _vm._l(_vm.locales, function (lang) {
                          return _c(
                            "vs-dropdown-item",
                            {
                              key: lang,
                              class: lang,
                              on: {
                                click: function ($event) {
                                  return _vm.changeLocale(lang)
                                },
                              },
                            },
                            [_c("p", [_vm._v(_vm._s(lang))])]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "section" },
            [_c("router-view", { on: { nameAccount: _vm.nameAccount } })],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo-wrapper" }, [
      _c("img", {
        staticClass: "logo",
        attrs: {
          src: require("../assets/img/logo_white.png"),
          alt: "Mashup logo",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }